import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Zap, ArrowRight, FileText, BookOpen } from 'lucide-react';

const HeroSection = ({ onActionClick }) => {
  
  const handleExternalLink = (url, ariaLabel) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="hero" className="relative min-h-[calc(100vh-4rem)] flex items-center justify-center text-center bg-gradient-to-br from-background via-background to-card/30 text-foreground overflow-hidden py-16 md:py-24">
      <div className="absolute inset-0 opacity-5 dark:opacity-[0.03]">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="heroGrid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M0 40 L40 40 L40 0" fill="none" stroke="currentColor" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#heroGrid)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <div className="inline-block px-4 py-1.5 mb-6 text-sm font-semibold tracking-wider text-primary bg-primary/10 rounded-full">
            Powerful PDF APIs for Developers
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 font-heading text-primary-foreground">
            Build Stunning <span className="gradient-text-brand">Document</span> Experiences
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-2xl mx-auto">
            Webfiny provides robust and scalable PDF manipulation APIs to streamline your document workflows, from generation and conversion to editing and security.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
          className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6 mb-16"
        >
          <Button 
            size="lg" 
            onClick={() => handleExternalLink('https://crafter.webfiny.com/', 'Get Started Free with WebFiny Crafter')} 
            className="bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg w-full sm:w-auto pulse-glow-brand"
            aria-label="Get Started Free with WebFiny Crafter in a new tab"
          >
            <Zap className="mr-2 h-5 w-5" />
            Get Started Free
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            onClick={() => handleExternalLink('https://www.postman.com/finycore/webfiny/overview', 'Explore WebFiny API Docs on Postman')} 
            className="border-input hover:border-primary text-foreground hover:text-primary w-full sm:w-auto"
            aria-label="Explore WebFiny API Docs on Postman in a new tab"
          >
            <BookOpen className="mr-2 h-5 w-5" />
            Explore API Docs
          </Button>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;